import type { SVGProps } from "react";

/**
 * chevron-right-medium
 * @category Arrows
 */
export default function IconChevronRightMedium(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M9.5 18.25L15.75 12L9.5 5.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
